import { useEffect, useMemo, useState, useRef, useCallback } from "react";
import Card from "../../../componentes/contenedores/Card";
import CardTipo from "../../../componentes/contenedores/CardTipo";
import Page from "../../../componentes/plantilla/Page";
import {
    ImagenProducto,
    ImagenTipoProducto
} from "../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import { InventariosGuardar, InventariosListar, ProductosListar } from "../../../configuracion/apiUrls";
import { mostraAlertaError, mostraAlertaOk, mostraAlertaPersonalizada, mostrarAlertaLoading } from "../../../componentes/alerts/sweetAlert";
import TablaInventarioPlana from "./TablaInventarioPlano";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import { formatoMoneda, parseNum } from "../../../configuracion/validaciones";
import moment from "moment";


const HomeInventarios = () => {
    const { listaProductos = [], listaTiposProductos = [], ActualizarLista, setListaInventarios, setListaProductos } = useContextEmpleado();
    const { usuario } = useContextUsuario();
    const [productosEnInventario, setProductosEnInventario] = useState([]);
    const [tiposDeProducto, setTiposDeProducto] = useState([]);
    const fechaDelDia = moment().format("dddd, DD [de] MMMM [de] YYYY");
    const productosRef = useRef(null);
    const [terminoBusquedaProducto, setTerminoBusquedaProducto] = useState("");
    const [productoSearchTerm, setProductoSearchTerm] = useState("");
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [notaInventario, setNotaInventario] = useState("");

    const configuracionPagina = {
        titulo: {
            titulo: "Generar inventarios fisico",
            url: "/app/admin/inventarios/nuevo",
            tituloUrl: "Menu Inventarios",
            nombreUrl: "Inicio",
        },
    };

    useEffect(() => {
        cargarTiposDeProducto();
    }, [listaTiposProductos]);

    const cargarTiposDeProducto = () => {
        if (Array.isArray(listaTiposProductos)) {
            const transformados = listaTiposProductos.map((tipo) => ({
                id: tipo.id,
                nombre: tipo.nombre,
                descripcion: tipo.descripcion,
                estado: tipo.estado,
                imagen: tipo.imagen
                    ? ImagenTipoProducto + tipo.imagen
                    : "/productos.jpg",
            }));
            setTiposDeProducto(transformados);
        }
    };

    const manejarActualizacionDeExistencia = useCallback((idProducto, idLote, idLoteInventario, nuevaExistencia) => {
        setProductosEnInventario(prevProductos => {
            return prevProductos.map(producto => {
                if (producto.id === idProducto) {
                    const nuevosLotes = producto.lotes.map(lote => {
                        if (lote.id === idLote) {
                            const nuevosInventarios = lote.loteinventarios.map(inventario => {
                                if (inventario.id === idLoteInventario) {
                                    return { ...inventario, existenciaActual: nuevaExistencia };
                                }
                                return inventario;
                            });
                            return { ...lote, loteinventarios: nuevosInventarios };
                        }
                        return lote;
                    });
                    return { ...producto, lotes: nuevosLotes };
                }
                return producto;
            });
        });
    }, []);

    const manejarEliminacionDeProducto = useCallback((idProducto) => {
        setProductosEnInventario(prevProductos => {
            return prevProductos.filter(producto => producto.id !== idProducto);
        });
    }, []);

    const transformarProductoParaInventario = useCallback((producto) => {
        const imgs = producto.productoImagens?.length > 0
            ? producto.productoImagens.map((img) => ImagenProducto + img.imagen)
            : ["/productos.jpg"];
        return {
            id: producto.id,
            nombre: producto.nombre,
            codigo: producto.codigo,
            precio: parseNum(producto.precio),
            costo: parseNum(producto.costo),
            existenciaSistema: parseNum(producto.existencia),
            existenciaActual: parseNum(producto.existencia),
            descripcion: producto.descripcion,
            imagenes: imgs,
            lotes: producto.lotes
                ?.filter(
                    lote =>
                        lote.estado !== "Agotado" &&
                        Number(lote.existencia) > 0
                )
                .map(lote => ({
                    ...lote,
                    loteinventarios: lote.loteinventarios.map(inv => ({
                        ...inv,
                        existenciaActual: inv.existencia
                    }))
                })) || [],
            estado: producto.estado
        };
    }, []);

    const aplicarFiltroPorTipo = useCallback((tipoId) => {
        if (tipoId === null) {
            setProductosEnInventario([]);
            return;
        }
        
        const productosModificados = productosEnInventario.filter(producto => {
            return producto.lotes.some(lote =>
                lote.loteinventarios.some(inv =>
                    (parseFloat(inv.existenciaActual) || 0) !== (parseFloat(inv.existencia) || 0)
                )
            );
        });

        const listaFiltradaBase = (
                tipoId === "todos"
                    ? listaProductos
                    : listaProductos.filter(
                        producto => producto.productoTipo.id === tipoId
                    )
            ).filter(producto =>
                producto.lotes?.some(
                    lote =>
                        lote.estado !== "Agotado" &&
                        Number(lote.existencia) > 0
                )
            );

        const nuevosProductosFiltrados = listaFiltradaBase.map(transformarProductoParaInventario);
        const idsModificados = new Set(productosModificados.map(p => p.id));

        const listaProductosFinal = [
            ...productosModificados,
            ...nuevosProductosFiltrados.filter(p => !idsModificados.has(p.id))
        ];
        console.log("Lista final de productos después del filtro:", listaProductosFinal);
        setProductosEnInventario(listaProductosFinal);

        setTimeout(() => {
            if (productosRef.current) {
                productosRef.current.scrollIntoView({ behavior: "smooth" });
            }
        }, 200);
    }, [productosEnInventario, listaProductos, transformarProductoParaInventario]);

    const agregarProductoAInventario = useCallback((producto) => {
        setProductosEnInventario(prevProductos => {
            const productoYaExiste = prevProductos.some(p => p.id === producto.id);
            if (productoYaExiste) {
                mostraAlertaError("Ya Agregado", `El producto ${producto.nombre} ya está en la lista.`);
                return prevProductos;
            }
            const nuevoProducto = transformarProductoParaInventario(producto);
            setModalIsOpen(false);
            mostraAlertaOk("Agregado", `Producto agregado.`);
            return [...prevProductos, nuevoProducto];
        });
    }, [transformarProductoParaInventario]);

    const resumenDeCierre = useMemo(() => {
        let totalSobrante = 0;
        let totalFaltante = 0;
        productosEnInventario.forEach(p => {
            p.lotes.forEach(lote => {
                lote.loteinventarios.forEach(inv => {
                    const balance = (inv.existenciaActual || 0) - (inv.existencia || 0);
                    const total = balance * (lote.costo || 0);
                    if (total > 0) totalSobrante += total;
                    else if (total < 0) totalFaltante += total;
                });
            });
        });
        return { totalSobrante, totalFaltante, cierreNeto: totalSobrante + totalFaltante };
    }, [productosEnInventario]);



    const guardarInventarioFisico = async () => {
        if (!productosEnInventario || productosEnInventario.length === 0) {
            return mostraAlertaError("Sin productos", "Lista vacía.");
        }

        const confirmacion = await new Promise((resolve) => {
            mostraAlertaPersonalizada({
                titulo: "¿Confirmar Guardado?",
                mensaje: "¿Desea registrar este inventario?",
                icono: "question",
                textoConfirmacion: "Sí, Guardar",
                textoCancelacion: "No, Cancelar",
                accion: (confirmado) => resolve(confirmado)
            });
        });

        if (!confirmacion) return;

        const detallesDeInventario = productosEnInventario.flatMap(producto => 
            (producto.lotes || []).flatMap(lote => {
                const costo = parseNum(lote.costo);

                return (lote.loteinventarios || []).map(inv => {
                    const existenciaSistema = parseNum(inv.existencia);
                    const existenciaActual = parseNum(inv.existenciaActual);
                    const balance = existenciaActual - existenciaSistema;
                    const cierre = balance * costo;

                    return {
                        productoId: producto.id,
                        loteId: lote.id,
                        loteInventarioId: inv.id,
                        existenciaSistema,
                        existenciaActual,
                        balance,
                        costo,
                        cierre: Number(cierre.toFixed(2)) // Redondeo limpio por ítem
                    };
                });
            })
        );

        const payload = {
            fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
            estado: "Activo",
            usuarioId: usuario?.id,
            totalSobrante: parseNum(resumenDeCierre?.totalSobrante).toFixed(2),
            totalFaltante: parseNum(resumenDeCierre?.totalFaltante).toFixed(2),
            totalCierre: parseNum(resumenDeCierre?.cierreNeto).toFixed(2),
            notas: notaInventario || "",
            detalles: detallesDeInventario,
        };

        try {
            await AxiosPublico.post(InventariosGuardar, payload);
            mostraAlertaOk("Inventario guardado.");
            ActualizarLista(InventariosListar, setListaInventarios);
            ActualizarLista(ProductosListar, setListaProductos);
            setProductosEnInventario([]);
            setNotaInventario("");
        } catch (error) {
            mostraAlertaError("Error", "Error al guardar.");
        }
    };

    const productosFiltradosVisibles = useMemo(() => {
        if (productosEnInventario.length === 0) return [];
        const termino = terminoBusquedaProducto.toLowerCase().trim();

        return productosEnInventario.filter(p => {
            const tieneModificacion = p.lotes.some(l => l.loteinventarios.some(i => i.existenciaActual !== i.existencia));
            if (tieneModificacion) return true;
            return (p.nombre + p.codigo).toLowerCase().includes(termino);
        });
    }, [productosEnInventario, terminoBusquedaProducto]);

    // Lógica de aplanamiento corregida para evitar duplicados y desorden
    const inventarioAplanadoUnificado = useMemo(() => {
        return productosFiltradosVisibles.flatMap(producto =>
            producto.lotes.flatMap(lote =>
                (lote.loteinventarios || []).map(inv => {
                    const existenciaSistema = parseFloat(inv.existencia || 0);
                    const existenciaActual = parseFloat(inv.existenciaActual || 0);
                    const balance = existenciaActual - existenciaSistema;
                    const costo = parseFloat(lote.costo || 0);

                    return {
                        productoId: producto.id,
                        productoNombre: producto.nombre,
                        productoCodigo: producto.codigo,
                        loteId: lote.id,
                        loteNombre: lote.nombre_lote,
                        loteInventarioId: inv.id,
                        tipoLote: inv.inventarioTipo.nombre,
                        precio: parseFloat(lote.precio || 0),
                        costo: costo,
                        existenciaSistema,
                        existenciaActual,
                        balance,
                        costoTotal: balance * costo,
                        handleActualizar: (nueva) => manejarActualizacionDeExistencia(producto.id, lote.id, inv.id, nueva),
                        handleEliminar: () => manejarEliminacionDeProducto(producto.id)
                    };
                })
            )
        );
    }, [productosFiltradosVisibles, manejarActualizacionDeExistencia, manejarEliminacionDeProducto]);

    const filteredProductos = listaProductos.filter((producto) =>
        (producto.nombre + producto.codigo).toLowerCase().includes(productoSearchTerm.trim().toLowerCase())
    ).map(p => ({
        ...p,
        imagen: p.productoImagens?.length > 0 ? ImagenProducto + p.productoImagens[0].imagen : "/productos.jpg"
    }));

    const [paginaActual, setPaginaActual] = useState(1);
    const indexUltimo = paginaActual * 5;
    const indexPrimero = indexUltimo - 5;
    const productosPagina = filteredProductos.slice(indexPrimero, indexUltimo);
    const totalPaginas = Math.ceil(filteredProductos.length / 5);

    return (
        <Page datos={configuracionPagina}>
            <Card titulo="Seleccione la categoria de productos">
                <CardTipo
                    categorias={[...tiposDeProducto, { id: "todos", nombre: "Todos", imagen: "/categoriaDefault.jpg" }]}
                    onSeleccionar={aplicarFiltroPorTipo}
                    activa={tiposDeProducto}
                />
            </Card>
            <Card>
                <h3 className="text-muted mb-3">{fechaDelDia}</h3>
                <div className="mb-1 d-flex">
                    <ModalBootstrap
                        titulo="Buscar y agregar"
                        nombreBoton="Buscar y agregar"
                        estiloBoton="btn btn-primary mb-2 mx-1"
                        iconBoton="fas fa-cart-plus"
                        modalIsOpen={modalIsOpen}
                        setModalIsOpen={setModalIsOpen}
                    >
                        <input
                            type="text"
                            className="form-control mb-3"
                            placeholder="Buscar..."
                            value={productoSearchTerm}
                            onChange={(e) => setProductoSearchTerm(e.target.value)} 
                            
                            />
                        <table className="table table-bordered">
                            <thead><tr><th>Imagen</th><th>Producto</th><th>Acción</th></tr></thead>
                            <tbody>
                                {productosPagina.map(p => (
                                    <tr key={p.id}>
                                        <td><img src={p.imagen} width="50" alt="" /></td>
                                        <td>{p.nombre} <br /> <small>{p.codigo}</small></td>
                                        <td><button className="btn btn-success btn-sm" onClick={() => agregarProductoAInventario(p)}><i className="fa-solid fa-cart-plus" /></button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <nav><ul className="pagination justify-content-center">
                            <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setPaginaActual(paginaActual - 1)}>Anterior
                                </button>
                            </li>
                            <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                <button
                                    className="page-link"
                                    onClick={() => setPaginaActual(paginaActual + 1)}>Siguiente
                                </button>
                            </li>
                        </ul></nav>
                    </ModalBootstrap>
                </div>

                <div className="row mb-4">
                    <div className="col-md-4"><h6>Sobrante:</h6><span className="text-success">{formatoMoneda(resumenDeCierre.totalSobrante)}</span></div>
                    <div className="col-md-4"><h6>Faltante:</h6><span className="text-danger">{formatoMoneda(Math.abs(resumenDeCierre.totalFaltante))}</span></div>
                    <div className="col-md-4 d-flex justify-content-between">
                        <div><h6>Total:</h6><span className={resumenDeCierre.cierreNeto >= 0 ? "text-success" : "text-danger"}>{formatoMoneda(resumenDeCierre.cierreNeto)}</span></div>
                        <div className="d-flex flex-column">
                            <button
                                className="btn btn-warning btn-sm mb-2"
                                onClick={() => aplicarFiltroPorTipo(null)}>Limpiar
                                <i className="fas fa-times mx-2" />
                            </button>
                            <button
                                className="btn btn-success btn-sm"
                                onClick={guardarInventarioFisico}>Guardar
                                <i className="fas fa-save mx-2" />
                            </button>
                        </div>
                    </div>
                </div>

                <div ref={productosRef}>
                    {inventarioAplanadoUnificado.length > 0 ? (
                        <TablaInventarioPlana datosInventario={inventarioAplanadoUnificado} />
                    ) : (
                        <div className="alert alert-info text-center">Seleccione productos para inventariar.</div>
                    )}
                    <div className="mt-4">
                        <label
                            className="fw-bold">Notas
                            </label>
                        <textarea
                            className="form-control"
                            rows="2"
                            maxLength={350}
                            value={notaInventario}
                            onChange={(e) => setNotaInventario(e.target.value)} 
                            />
                    </div>
                </div>
            </Card>
        </Page>
    );
};

export default HomeInventarios;